import MainLayout from './layouts/MainLayout/MainLayout';
import PublicLayout from './layouts/PublicLayout/PublicLayout';

import Home from './pages/Home/Home';
import Launchpad from './pages/Launchpad/Launchpad';
import UserRoute from './routes/UserRoute';
import GuestRoute from './routes/GuestRoute';
import Login from './pages/Login/Login';
import SignUp from './pages/SignUp/SignUp';
import ProjectDetail from './pages/ProjectDetail/ProjectDetail';

import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ProjectForm from './pages/ProjectForm';
import Activation from './pages/Activation/Activation';
import Unsubscribe from './pages/Unsubscribe/Unsubscribe';
import { Redirect, Route } from 'react-router-dom';
import Profile from './pages/Profile/Profile';
import Sales from './pages/Sales/Sales';
import Staking from './pages/Staking/Staking';
import Locking from './pages/Locking/Locking';
import Whitepaper from './pages/Whitepaper/Whitepaper';
import About from './pages/About/About';
import Terms from './pages/Terms/Terms';
import MyTickets from './pages/MyTickets/MyTickets';

function SalesRedirect({ ...props }) {
  const { location } = props;

  return (
    <Redirect
      to={{
        pathname: '/sales/token',
        search: location?.search,
        hash: location?.hash,
      }}
    />
  );
}

function LegacyProjectRedirect({ ...props }) {
  const { match, location } = props;
  const projectId = match?.params?.id;
  const projectDetailPath = `/sales/token/project/${projectId}`;

  return (
    <Redirect
      to={{
        pathname: projectDetailPath,
        search: location?.search,
        hash: location?.hash,
      }}
    />
  );
}

const routes = {
  PublicLayout: {
    exact: true,
    name: 'Public Layout',
    component: PublicLayout,
    children: [
      {
        path: '/login',
        exact: true,
        name: 'Login',
        component: Login,
        routeComponent: GuestRoute,
      },
      {
        path: '/ProjectAdd',
        exact: true,
        name: 'Project Form',
        component: ProjectForm,
        routeComponent: Route,
      },
      {
        path: '/forgotpassword',
        exact: true,
        name: 'Forgot Password',
        component: ForgotPassword,
        routeComponent: GuestRoute,
      },
      {
        path: '/reset-password',
        exact: true,
        name: 'Reset Password',
        component: ResetPassword,
        routeComponent: GuestRoute,
      },
      {
        path: '/Unsubscribe',
        exact: true,
        name: 'Unsubscribe',
        component: Unsubscribe,
        routeComponent: Route,
      },
      {
        path: '/activate_user',
        exact: true,
        name: 'Activation',
        component: Activation,
        routeComponent: Route,
      },
      {
        path: '/SignUp',
        exact: true,
        name: 'Sign Up',
        component: SignUp,
        routeComponent: GuestRoute,
      },
    ],
  },
  MainLayout: {
    exact: true,
    name: 'Main',
    component: MainLayout,
    children: [
      {
        path: '/',
        exact: true,
        name: 'Empty Page',
        component: Home,
        routeComponent: Route,
      },
      {
        path: '/Launchpad',
        name: 'Launchpad',
        component: Launchpad,
        routeComponent: Route,
      },
      {
        path: '/Profile',
        name: 'Profile',
        component: Profile,
        routeComponent: UserRoute,
      },
      {
        path: '/my-tickets',
        exact: true,
        name: 'My Tickets',
        component: MyTickets,
        routeComponent: UserRoute,
      },
      {
        path: '/sales',
        exact: true,
        name: 'Token Sales',
        component: SalesRedirect,
        routeComponent: Route,
      },
      {
        path: '/sales/token',
        exact: true,
        name: 'Token Sales',
        component: Sales,
        routeComponent: Route,
      },
      {
        path: '/sales/nft',
        exact: true,
        name: 'NFT Sales',
        component: Sales,
        routeComponent: Route,
      },
      {
        path: '/sales/token/project/:id',
        exact: true,
        name: 'Token Sale Project Detail',
        component: ProjectDetail,
        routeComponent: Route,
      },
      {
        path: '/sales/nft/project/:id',
        exact: true,
        name: 'NFT Sale Project Detail',
        component: ProjectDetail,
        routeComponent: Route,
      },
      {
        path: '/locking',
        name: 'Locking',
        component: Locking,
        routeComponent: Route,
      },
      {
        path: '/staking',
        name: 'Staking',
        component: Staking,
        routeComponent: Route,
      },
      {
        path: '/project/:id',
        exact: true,
        name: 'Legacy Project Detail Redirect',
        component: LegacyProjectRedirect,
        routeComponent: Route,
      },
      {
        path: '/about',
        name: 'Project Detail',
        component: About,
        routeComponent: Route,
      },
      {
        path: '/terms',
        name: 'Project Detail',
        component: Terms,
        routeComponent: Route,
      },
      {
        path: '/whitepaper',
        name: 'Project Detail',
        component: Whitepaper,
        routeComponent: Route,
      },
    ],
  },
};

export default routes;
